module.exports = __webpack_public_path__ + "static/media/Data_insight_1-2.1ccb0648.svg";